/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-03-21 16:51:03
 * @FilePath: /vise/packages/app-share/src/composable/use-video-event-handler/index.ts
 */
import { getCurrentInstance, onMounted, onUnmounted } from 'vue';
import EventEmitter from 'events';
import { EVideoEvtNameTypes } from '@/constants/video';

type EventParams = { eventName: EVideoEvtNameTypes, index: number };
export type OnVideoEvent = (params: EventParams) => void;

const getEvtBus = () => {
  const internalInstance = getCurrentInstance();
  const { $evtBus } = internalInstance?.appContext?.config?.globalProperties || {};
  return $evtBus as EventEmitter;
};

export default function () {
  const $evtBus = getEvtBus();
  const emitVideoEvent = (eventParams: EventParams) => {
    $evtBus.emit(EVideoEvtNameTypes.change, eventParams);
  };

  const listenVideoEvent = (onVideoEvent: OnVideoEvent) => {
    $evtBus.on(EVideoEvtNameTypes.change, onVideoEvent);
  };

  const unlistenVideoEvent = (onVideoEvent: OnVideoEvent) => {
    $evtBus.off(EVideoEvtNameTypes.change, onVideoEvent);
  };
  const useVideoEvent = (onVideoEvent: OnVideoEvent) => {
    onMounted(() => {
      listenVideoEvent(onVideoEvent);
    });
    onUnmounted(() => {
      unlistenVideoEvent(onVideoEvent);
    });
  };
  return {
    emitVideoEvent,
    listenVideoEvent,
    unlistenVideoEvent,
    useVideoEvent,
  };
};
